import { useMemo } from 'react';
import cn from 'classnames';
import { Checkbox } from '@material-ui/core';

import layoutStyles from '../../../layout.module.css';
import { makeMessage, postMessageToParent } from '../../utils';
import EmptyCheck from '../../../components/EmptyCheck';
import styles from './index.module.css';

function getCellName({ rowIndex, row, isDisplayLineItems }) {
    switch (true) {
        case rowIndex === 0 && isDisplayLineItems:
            return 'Lots and Line Items';
        case rowIndex === 0:
            return 'Lots';
        case Boolean(row):
            return `${row.title} ${row.num}: ${row.name || ''}`;
        default:
            return '';
    }
}

const AssignmentFirstColumn = ({
    rowIndex,
    rows,
    rootStyle,
    isDisplayLineItems,
    thStyle,
    suppliers,
    isLoading,
    isDisabled
}) => {
    const row = rowIndex > 0 ? rows[rowIndex - 1] : undefined;
    /**
     * @type {string}
     * 
     * title is a string having inner html of a multiline div
     * because line item name is required to be a multiline
     * 
     * this also affects the way you bind the field to the template
     * rather than a simple interpolation, we have to bind it as
     * html of target container
     */
    const title = getCellName({ rowIndex, row, isDisplayLineItems });
    const isAllAssigned = useMemo(() => {
        return row && row.variant === 'lot' && Array.isArray(suppliers)
            ? Object.keys(row.suppliers).length === suppliers.length
            : false;
    }, [row, suppliers]);

    const handleAssignAll = event => {
        if (isLoading && row !== 'lot') {
            return;
        }
        const assignAllEvent = makeMessage('assignLotAll', {
            checked: event.target.checked,
            lotIndex: row.num - 1
        });
        postMessageToParent(assignAllEvent);
    };

    if (rowIndex === 0) {
        return (
            <div style={rootStyle}>
                <div className={cn(thStyle, layoutStyles.borderLeft)}>
                    &nbsp;
                </div>
                <div
                    className={cn(
                        thStyle,
                        styles.rowTitle,
                        layoutStyles.borderLeft
                    )}
                >
                    {title}
                </div>
            </div>
        );
    }

    return (
        <div
            style={rootStyle}
            className={cn(
                styles.root,
                layoutStyles.borderLeft,
                layoutStyles.borderBottom,
                layoutStyles.borderRight,
                layoutStyles.flex
            )}
            title='Assign Lot to All Suppliers'
        >
            <div
                className={cn(layoutStyles.flex1, styles.rowName, {
                    [styles.lotName]: row?.variant === 'lot'
                })}
                dangerouslySetInnerHTML={{
                    __html: title.length > 35 ? title.slice(0, 35) + "..." : title
                }}
            >
            </div>
            {row.variant === 'lot' && (
                <Checkbox
                    icon={<EmptyCheck />}
                    disabled={isDisabled}
                    onChange={handleAssignAll}
                    checked={isAllAssigned}
                    className={styles.checkbox}
                />
            )}
        </div>
    );
};

export default AssignmentFirstColumn;
